import itemDialogReducer from './itemDialogReducer';

export default itemDialogReducer;